'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';

const FlagSzAsset = ({ width, height, ...props }, ref) => /* @__PURE__ */ jsxs(
  "svg",
  {
    viewBox: "0 0 28 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width,
    height,
    ref,
    "aria-hidden": true,
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M1.2815e-06 0C9.33333 4.27931e-08 18.6667 -4.7342e-05 28 5.1558e-06V20C18.6667 20 9.33333 20 0 20C0 13.3333 -8.25953e-06 6.66667 1.2815e-06 0Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M0 4H28V5.1558e-06L1.2815e-06 0L0 4Z",
          fill: "#486BCA"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M0 20H28V16H0V20Z",
          fill: "#486BCA"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M0 16H28V4H0V16Z",
          fill: "#FFDF20"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M0 14.6667H28V5.33333H0V14.6667Z",
          fill: "#CF1615"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M14 13.3333C17.3137 13.3333 20 10 20 10C20 10 17.3137 6.66667 14 6.66667C10.6863 6.66667 8 10 8 10C8 10 10.6863 13.3333 14 13.3333Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M14.6665 6.66667C14.6665 6.66667 13.3333 6.36341 11.1538 7.43253C8.97437 8.50165 8 10 8 10C8 10 9.29692 11.8225 10.5 12.5C11.5049 13.0659 13.3332 13.3333 13.3332 13.3333L14.6665 6.66667Z",
          fill: "#262626"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M15.3332 10.6667C15.7014 10.6667 15.9998 10.3682 15.9998 10C15.9998 9.63183 15.7014 9.33335 15.3332 9.33335C14.965 9.33335 14.6665 9.63183 14.6665 10C14.6665 10.3682 14.965 10.6667 15.3332 10.6667Z",
          fill: "#1A1A1A"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M12.6667 10.6667C13.0349 10.6667 13.3333 10.3682 13.3333 10C13.3333 9.63181 13.0349 9.33333 12.6667 9.33333C12.2985 9.33333 12 9.63181 12 10C12 10.3682 12.2985 10.6667 12.6667 10.6667Z",
          fill: "#F6F6F6"
        }
      )
    ]
  }
);
const VpFlagSzAsset = forwardRef(FlagSzAsset);

export { VpFlagSzAsset as default };
